import { createPortal } from "react-dom";
import { useMap } from "react-leaflet";
import { useDispatch } from "react-redux";
import { setModal } from "../../store/reducers/helpersReducer";
import AccountingSheetView from "../contents/AccountingSheetView";
import { Dialog } from "@mui/material";

const ModalAccountingSheetTable = (props) => {
    const map = useMap();
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(setModal(null));
    };

    return (
        // createPortal(
        <Dialog
            open={true}
            fullScreen={true}
            maxWidth="lg"
        >
            <AccountingSheetView
                isModal={true}
                onClose={handleClose}
                map={map}
                fromStartPage={false}
            />
        </Dialog>
        // ,
        //     document.body
        // )
    );
};

export default ModalAccountingSheetTable;
